"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInput = setInput;
exports.setShowError = setShowError;
exports.setUserSearchedClaims = setUserSearchedClaims;
function setInput(input) {
    return {
        type: "set-input",
        input: input
    };
}
function setShowError(showError) {
    return {
        type: "set-show-error",
        showError: showError
    };
}
function setUserSearchedClaims(claims) {
    return {
        type: "set-user-searched-claims",
        claims: claims
    };
}
//# sourceMappingURL=actions.js.map